import { BaseComponent, BaseFullscreenToggle, BaseSpacer } from '../base'
import { CloseButton } from '../close-button'
import { ClosedCaptionsButton } from '../closed-captions-button'
import { ControlBar } from '../control-bar'
import { PipButton } from '../pip-button'
import { PlayButton } from '../play-button'
import { PlayNext } from '../play-next'
import { PlayPauseAnimation } from '../play-pause-animation'
import { PlayPrevious } from '../play-previous'
import { defaultPlayer } from '../player/default-player'
import { Poster } from '../poster'
import { ArrowSeekHandlers, ProgressControl } from '../progress-control'
import { RewindButton } from '../rewind-button'
import { SeekToLive } from '../seek-to-live'
import { Settings } from '../settings'
import { TapToUnmute } from '../tap-to-unmute'
import { Title } from '../title'
import { VolumePanel } from '../volume-panel'
import { Player } from './player'

import './alternative-player.css'
import './disable-player-mode.css'

export const alternativePlayer = Player.as(
  `${defaultPlayer.className}.vjs-x-player-alt`,
  [
    // Top bunk
    BaseComponent.as('.vjs-x-top-bunk', [
      // currently playing video title
      Title,

      // space between title and close button
      BaseSpacer,

      // toggle Picture-in-Picture
      PipButton,

      // chromecast button
      // https://github.com/silvermine/videojs-chromecast/blob/ee87f9bcad423b48560cbb5340b5b577d61af853/src/js/components/ChromecastButton.js
      'chromecastButton',

      // close button
      CloseButton,
    ]),

    // Middle bunk
    BaseComponent.as('.vjs-x-middle-bunk', [
      Poster,

      // for "touch" devices only
      PlayPrevious,
      PlayButton,
      PlayNext,

      // Animation of play / pause on L / XL screens
      PlayPauseAnimation,

      // "Tap to unmute button" for touch devices combined
      TapToUnmute,
    ]),

    // Bottom bunk
    BaseComponent.as('.vjs-x-bottom-bunk', [
      // progress control
      ProgressControl,

      // Keyboard seek handlers
      ArrowSeekHandlers.as({ fullscreenOnly: true }),

      // control bar with play/pause, volume, live indicator(button) and so on controls
      ControlBar.as('.vjs-x-control-bar', [
        // central play toggle button
        PlayButton,

        // rewind left button
        RewindButton.as('.vjs-x-rewind-button.vjs-x-rewind-left-button'),

        // rewind right button
        RewindButton.as('.vjs-x-rewind-button.vjs-x-rewind-right-button'),

        // MuteToggle and VolumeControl combined
        VolumePanel,

        // status of live edge and button to seek to live edge
        SeekToLive,

        // space to move latter controls to the right side
        BaseSpacer,

        // Play next content button
        PlayPrevious,

        // Play previous content button
        PlayNext,

        // // Show program view btn.
        // ProgramButton,

        // // Tv btn.
        // TvButton,

        // Closed Captions button
        ClosedCaptionsButton,

        // Settings control, with button and menu
        Settings,

        // toggle fullscreen video
        BaseFullscreenToggle.as(),
      ]),
    ]),
  ]
)
